import React, { useState, useRef, useEffect } from "react";
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_bus";
import "./PdfPage.css";

export default function TemplatePage(props) {
  const { isLoading, error, sendReq: fetchData } = useHttp();

  const [refreshDate, setRefreshDate] = useState("");

  const logoRef = useRef(null);
  const middleImageRef = useRef(null);
  const footerImageRef = useRef(null);
  const footerRightImageRef = useRef(null);
  const lastPageImageRef = useRef(null);

  useEffect(() => {
    fetchData(
      {
        url:
          API_URL_MAIN + "energy_analysis_bus/energy_analysis_refreshdate_bus",
        body: {},
      },
      refreshDateData
    );
  }, []);

  const refreshDateData = (data) => {
    setRefreshDate(data.value_as_string);
  };
  useEffect(() => {
    props.setRefs({
      logo: logoRef.current,
      middleImage: middleImageRef.current,
      footerImage: footerImageRef.current,
      footerRightImageRef: footerRightImageRef.current,
      lastPageImageRef: lastPageImageRef.current,
    });
  }, []);

  return (
    <div className="firstpage">
      <div className="row" style={{ justifyContent: "end" }}>
        <img
          ref={logoRef}
          src="../../../assets/img_Bus/Pdf_Page/Tatamotors.png"
          alt=""
          style={{ height: "80px", width: "250px" }}
        />
      </div>
      <div className="row">
        <div
          className="col-md-6"
          style={{ paddingTop: "150px", paddingLeft: "80px" }}
        >
          <h3
            style={{ color: "black", fontWeight: "bolder", fontSize: "18px" }}
          >
            CESL E-Buses
          </h3>
          <h3 style={{ color: "#607ec8", fontSize: "14px" }}>
            Performance and Trend Analytics
          </h3>

          <p style={{ paddingTop: "100px", color: "#607ec8" }}>
            Data considered for : {props.startdate} - {props.enddate}
          </p>
          <p style={{ color: "#607ec8" }}>Data Analytics Team</p>
        </div>
        <div className="col-md-6">
          <img
            ref={middleImageRef}
            src="../../../assets/img_Bus/Pdf_Page/Middle.png"
            alt=""
            style={{ height: "400px", width: "550px" }}
          />
        </div>
      </div>
      <div className="row bottom-content pl-4" style={{ paddingTop: "385px" }}>
        <div className="col-md-3">
          <img
            ref={footerImageRef}
            src="../../../assets/img_Bus/Pdf_Page/footer.png"
            alt=""
            style={{ height: "70px", width: "200px" }}
          />
        </div>
        <div className="col-md-1"></div>
        <div className="col-md-4">
          <p
            style={{
              fontSize: "11px",
              paddingTop: "60px",
              paddingLeft: "10px",
            }}
          >
            Copyright, Confidential, Tata Motors Limited
          </p>
        </div>
        <div className="col-md-3">
          <img
            ref={footerRightImageRef}
            src="../../../assets/img_Bus/Pdf_Page/bottomcorner.png"
            alt=""
            style={{ height: "70px", width: "200px" }}
          />
        </div>
      </div>
      <div className="row">
        <img
          ref={lastPageImageRef}
          src="../../../assets/img_Bus/Pdf_Page/thankyoupage.png"
          alt=""
          style={{ height: "300px", width: "700px" }}
        />
      </div>
    </div>
    // </div>
  );
}
